import * as layout from '../layout.js';
import debounce from 'debounce';
import Masonry from 'masonry-layout';
import { Fancybox } from "@fancyapps/ui";

function initMasonry() {
    const grid = new Masonry( '.gallery-content__masonry-container', {
        itemSelector: '.gallery-content__masonry-item',
    })
}

function initFancyBox() {
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });
}

window.addEventListener('load', () => {

    layout.initStickyNavbar()

    initMasonry();
    initFancyBox();

})